<button
  attr.color="{{ buttonColor }}"
  mat-raised-button
  type="button"
  [ngClass]="{
    'doc-read-lookup-button':
      fieldData.type === 'custom-manual-lookup-document',
  }"
  (click)="startSession()"
>
  <mat-icon>search</mat-icon>
  {{ this.buttonLabel }}
</button>
